import * as THREE from 'three'
import { Object3D } from 'three'
export default class GrabbableObject extends Object3D {

    constructor(controls, rotation) {
        super()
        this.controls = controls
        this.worldPosition = new THREE.Vector3()
        this.childPosition = new THREE.Vector3()
        this.previousRotation = rotation
        this.addBindings()
        this.addEventListeners()
    }

    addBindings() {
        this.onClick = this.onClick.bind(this)
        this.onClickEnd = this.onClickEnd.bind(this)
        this.handleMove = this.handleMove.bind(this)
    }

    addEventListeners() {
        this.controls.addEventListener('selectStart', this.onClick)
        this.controls.addEventListener('selectEnd', this.onClickEnd)
        this.controls.addEventListener('rayMove', this.handleMove)
    }

    removeEventListeners() {
        this.controls.removeEventListener('selectStart', this.onClick)
        this.controls.removeEventListener('selectEnd', this.onClickEnd)
        this.controls.removeEventListener('rayMove', this.handleMove)
    }

    onClick(event) {
        const evt = event.data
        const intersecting = this.checkForIntersects(evt)
        if (intersecting) {
            this.getWorldPosition(this.worldPosition)
            this.rotation.clone(this.previousRotation)
            this.childPosition = this.children[0].position.clone()
            this.children[0].position.set(0, 0, -0.2)
            this.grabDistance = intersecting.distance
            this.moving = intersecting.distance ? true : false
            const existingObject = this.controls.intersectableObjects.find(v => v.uuid === intersecting.object.uuid)
            if (!existingObject) this.controls.intersectableObjects = [...this.controls.intersectableObjects, intersecting.object]
        }
    }

    onClickEnd(evt) {
        try {
            if (this.moving) {
                this.moving = false
                this.controls.scene.attach(this)
                this.children[0].position.set(this.childPosition.x, this.childPosition.y, this.childPosition.z)
                this.position.set(this.worldPosition.x, this.worldPosition.y, this.worldPosition.z)
                this.setRotationFromEuler(this.previousRotation)
            }
        } catch (e) {
            console.log(e)
        }
        this.dispatchEvent({ type: 'clickEnd' })
    }


    handleMove(evt) {
        try {
            if (!this.moving) return
            const raycaster = evt.data.raycaster
            if (!raycaster) return
            const controller = evt.data.controller
            controller.attach(this)
            this.position.set(0, 0, -0.15)
            this.dispatchEvent({ type: 'moving' })
        } catch (e) {
            console.log(e)
        }
    }



    checkForIntersects(evt) {
        if (evt && evt.raycaster) {
            const raycaster = evt.raycaster
            const intersect = raycaster.intersectObject(this, true)
            if (intersect.length > 0) {
                return intersect[0]
            } else return false
        }
        else return false
    }
}